import { useIntl, defineMessages } from 'react-intl'
import { Card, Text, Heading, Icon, Stack, Box, Flex } from '@homebotapp/hb-react-component-catalog'
import { NATIONAL_AVG_DOWN_PAYMENT } from '../../Utilities/EstimatedMonthlyPaymentConstants'

export const MSG = defineMessages({
  downPaymentHead: {
    id: 'EstimatedMonthlyPaymentBreakdown.downPaymentHead',
    defaultMessage: 'We are using {natlAvg}% as your down payment'
  },
  downPaymentDescription: {
    id: 'EstimatedMonthlyPaymentBreakdown.downPaymentDescription',
    defaultMessage: 'This is the current national average'
  }
})

export const EstimatedMonthlyPaymentBreakdownNationalAvgDownPaymentCard = () => {
  const intl = useIntl()

  return (
    <Card p={4} direction='row' gap={[3, 4]} alignItems='center' borderRadius='lg'>
      <Flex display={['none', 'block']}>
        <Icon name='info-circle' width={[4, 4, 6]} height={[4, 4, 6]} color='neutral.600' display='block' />
      </Flex>
      <Stack gap={0}>
        <Heading as='h4' size={['2xs', 'xs']}>
          {intl.formatMessage(MSG.downPaymentHead, {
            // Trim trailing 0's after the decimal
            natlAvg: parseFloat((NATIONAL_AVG_DOWN_PAYMENT * 100).toFixed(2))
              .toString()
              .replace(/(\.\d*?[1-9])0+$/, '$1')
          })}
        </Heading>
        <Text mb={0} size={['2xs', 'xs']}>
          {intl.formatMessage(MSG.downPaymentDescription)}
        </Text>
      </Stack>
    </Card>
  )
}
